class loadMoreBtn extends HTMLElement {
    constructor() {
        super();

        this.mainBlog = document.querySelector("[js-main-blog]");
        this.mainBlogGrid = this.mainBlog.querySelector("[js-blog-grid]");
        this.sectionId = this.mainBlog.dataset.sectionId
        
        this.init();

        document.addEventListener("load-more:init", this.init.bind(this))
    };

    init() {
        const loadMoreBtn = this.querySelector("[js-load-more-btn]");

        if(loadMoreBtn) {
            loadMoreBtn.addEventListener('click', (e) => {
                e.preventDefault();
                this.renderProducts(e.currentTarget);
            });
        }
    };

    renderProducts(btn) {
        const href = btn.getAttribute("href");
        let ajaxGrid;
        let url;

        if(href.includes("search")) {
            url = href;
            ajaxGrid = "[js-main-search]"
        }else {
            url = `${href}&section_id=${this.sectionId}`;
            ajaxGrid = "[js-blog-grid]";
        };

        btn.classList.add("btn-loading");
        btn.innerHTML = 'loading...';

        fetch(url)
        .then(function(response) {
          return response.text();
        }).then((html) => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            const blogGrid = doc.querySelector(ajaxGrid);
            const loadMoreEl = doc.querySelector('.js-load-more-btn');
            this.mainBlogGrid.insertAdjacentHTML("beforeend", blogGrid.innerHTML);
            this.innerHTML = loadMoreEl.innerHTML;
            this.init();

            btn.classList.remove('btn-loading');
            btn.innerHTML = 'Load More Articles';
        }); 
    }
}
  
customElements.define('load-more-btn', loadMoreBtn);
  